import React from 'react'
import {HandlePageWelcome} from '../../../../../context/HandlePageWelcome'
import {MDBBtn, MDBContainer, MDBTypography} from 'mdb-react-ui-kit'
import {AiFillCaretLeft, AiFillCaretRight} from 'react-icons/ai'
import {FiPocket} from 'react-icons/fi'
const LevelTwo = () => {
  const {page, setPage} = React.useContext(HandlePageWelcome)
  return (
    <div style={{ height: '95%' }} dir={'rtl'} className={'flex flex-col justify-between'}>
      <div>
        <div className={'mt-5'}>
          <h1 className={'text-white text-5xl '}>امنیت سرمایه گذاری</h1>
          <br />
          <hr className={'bg-white  h-5'} />
        </div>
        <div className={'mt-2 mb-2 text-center'}>
          <FiPocket className={'text-white'} size={150} />
        </div>
        <div className={'mt-2'}>
          <p className={'text-white bk-light leading-10 text-1xl font-light'}>
            اعضای هیئت  مدیره شرکت شرکت سهامی مهر ایرانیان امنیت سرمایه گذاران را تضمین نموده و از نمایندگان سهامداران در طول ساخت پروژه به عنوان ناظر بر پیشرفت کار و سرمایه  سهامداران در پروژه استفاده خواهد شد
            هیئت مدیره شرکت سهامی مهر ایرانیان از پزشکان خوشنام بوده  و در کارنامه کاری خودشان  ساخت و تجهیز و راه اندازی در مانگاه و مراکز جراحی محدوده پرند  را دارند که خود نمونه ای از یک مرکز درمانی موفق در شهر پرند می بیاشد          .
          </p>
        </div>
      </div>
      <div className={'flex justify-between'}>
        <MDBBtn color='light' outline className={'rounded-lg'}  onClick={() => setPage(1)}>
          <AiFillCaretRight />
          مرحله قبل
        </MDBBtn>
        <MDBBtn color='light' className={'rounded-lg'}  onClick={() => setPage(3)}>
          مرحله بعد
          <AiFillCaretLeft  />
        </MDBBtn>
      </div>
    </div>
  )
}

export default LevelTwo